import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-pay-info-dialog',
  templateUrl: './pay-info-dialog.component.html',
  styleUrls: ['./pay-info-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayInfoDialogComponent {
  constructor(private dialog: MatDialog) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
